<div class="chip-input-wrapper">
  <mat-form-field>
    <mat-label>{{ chipLabel }}</mat-label>
    <mat-chip-grid #chipList [formControl]="extensionChipsControl" [required]="isRequired">
      @for (value of displayValues; track value; let i = $index) {
        <mat-chip-row
          [selectable]="false"
          [removable]="true"
          (removed)="removeValue(value)"
          >{{ value | formatPhoneNumberOrExtension }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
      <input
        autocomplete="off"
        #extensionInput
        type="text"
        [formControl]="extensionInputControl"
        [lcsSingleSelect]="extensionSelect"
        name="extension-filter"
        [allowManualInput]="true"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="add($event)"
        (blur)="removeErrors()"
        ndtExtensionSelect
        [openPanelOnFocus]="true"
        [accountId]="accountId"
        [extensionType]="extensionType"
        [placeholder]="extensionInputControl.enabled ? 'Search' : ''"
        />
      </mat-chip-grid>
      @if (extensionChipsControl.hasError('required')) {
        <mat-error> Please select an option </mat-error>
      }
      @if (extensionChipsControl.hasError('invalidPhoneNumber')) {
        <mat-error>
          Please enter a valid phone number.
        </mat-error>
      }
      @if (extensionChipsControl.hasError('duplicatePhoneNumber')) {
        <mat-error>
          Phone Number is already added
        </mat-error>
      }
      <ndt-extension-select
        #extensionSelect
        (optionSelected)="selected($event)"
        [extensionsToExclude]="displayExtensions"
        [excludedIds]="excludedIds"
        [autoActiveFirstOption]="false"
      ></ndt-extension-select>
    </mat-form-field>
  </div>
